export default __webpack_public_path__ + "static/media/search-list-no-result.44de397f.svg";